import ObjPropParser from "@/classes/ObjPropParser";
import ParentComms from "@/classes/ParentComms";
import Lytics from "@/classes/Lytics";
import {merge} from "lodash";

const config = {};

function parseJSON(json, sources = {}) {
	return ObjPropParser.Parse(json, {env: process.env, ...sources});
}

async function mergeConfigs(files) {
	let o = {};
	for(let i in files) {
		const config = await fetch(`/config/${files[i]}`);
		const json = await config.json();
		o = merge(o, json);
	}
	return o;
}

export default class {
	/**
	 * Asynchronously loads and merges configuration files or fetches configuration data
	 * from a remote source based on the provided parameters.
	 *
	 * @param {string} conf - The name or identifier of the configuration to load.
	 * @param {string} [arg=''] - An optional argument used as an additional identifier for fetching.
	 * @param {boolean}parse - Perform ObjPropParser.Parse on the loaded configuration data.
	 * @param sources - Source data for use in parsing configuration
	 * @return {Promise<Object|undefined>} A promise that resolves with the loaded configuration object
	 * or undefined in case of an error.
	 */
  static async LoadConfig(conf, arg = '', parse = false, sources = {}) {
	  console.log('LoadConfig:', conf, arg, sources);
		try{
			if(arg)arg = `-${arg}`
			const ver= Math.random();
			const files = this.AppConf?.flyerConfig?.merge?.files;

			if(files){
				const _config = parse? parseJSON(await mergeConfigs(files), sources): await mergeConfigs(files);
				config[conf] = _config;
				return _config;
			}
			const _config = await fetch(`/config/${conf}${arg}.json?v=${ver}`);
			const json = parse? parseJSON(await _config.json(), sources): await _config.json();
			config[conf] = json;
			return json;
		} catch (e) {
			console.log(`Config File '${conf} failed to load.`, e);
		}
	}
	static get AppConf() {
		return config['app'];
	}

	static ParseEvent(events = {}, data = null) {
		for(let p in events) {
			const eventData = ObjPropParser.Parse(events[p] , data);
			switch(p) {
				case 'postMessage':
					//console.log('ParseEvent PostMessage:', data)
					ParentComms.SendData(eventData);
				break;
				case 'analytic':
					Lytics.TriggerEvent(eventData.event, eventData.data)
				break;
			}
		}

	}
}
